module.exports = __webpack_public_path__ + "img/teamsdoublearrow.7baa16d1.svg";